// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3Jp90","validationTips":"StatementDescriptor_validationTips__1Zpy-"};